import React, { useState } from 'react';
import { Row, Col, Spin, Result } from 'antd';
import WipoTrademarkCard from './WipoTrademarkCard';
import WipoModal from './WipoModal';


const WipoResultsGrid = ({
  items = '',
  loading = false,
  error = null,
  loadingTip = 'Загрузка…',
  errorTitle = 'Ошибка',
  emptyTitle = 'Результатов не найдено',
  requestType = '',
  searchQuery = '',
}) => {
  const [openDoc, setOpenDoc] = useState(null);
  if (loading) return <Spin tip={loadingTip} size="large" />;
  if (error) return <Result status="error" title={errorTitle} subTitle={error} />;
  if (items === '') return <></>;
  if (!items?.length) return <Result status="info" title={emptyTitle} />;

  return (
    <>
      <Row gutter={[16, 16]}>
        {items.map((item, idx) => (
          <Col key={idx} xs={24} sm={12} md={8} lg={6}>
            <WipoTrademarkCard
              data={item.document || item}
              base64Image={item.base64Image}
              score={item.score}
              requestType={requestType}
              searchQuery={searchQuery}
              onClick={() => setOpenDoc(item)}
            />
          </Col>
        ))}
      </Row>
      {openDoc && (
        <WipoModal
          open={!!openDoc}
          onClose={() => setOpenDoc(null)}
          data={openDoc.document || openDoc}
          imgSrc={openDoc?.base64Image ? `data:image/jpg;base64,${openDoc.base64Image}` : null}
        />
      )}
    </>
  );
};

export default WipoResultsGrid;


